module.exports = __webpack_public_path__ + "static/img/ydyl6.ac5ab0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ydyl6.jpg
// module id = uW5I
// module chunks = 0